import { RootState } from '../../../store/reducers';
import { SchoolWidgetGroupDto } from '../SchoolWidgetGroups/school-widget-groups.dto';
import { WidgetDTO } from './components/EditableWidget/EditableWidget.constants';

export const selectSchoolWidgetsList = (state: RootState): WidgetDTO[] => state.commercial.schoolWidgets.widgets;

export const selectSchoolWidgetGroup = (state: RootState): SchoolWidgetGroupDto =>
  state.commercial.schoolWidgets.widgetGroup;
